<template>
  <section id="info-adoption" class="w-full flex-1 max-w-5xl items-center mx-auto px-5 shadow-sm mb-20 pt-20">
    <Titre textePrincipal="Informations pour les " texteAccentue="adoptions" :isSidebarOpen="isSidebarOpen" />

    <div
      class="flex flex-row flex-wrap justify-center w-full mx-auto mt-10 rounded-lg shadow-sm px-4">

      <sectionCard v-for="(section, index) in sections" :key="index" :title="section.title" :content="section.content"
        :imageSrc="section.imageSrc" :imageAlt="section.imageAlt" :imageTitle="section.imageTitle"
        :imagePosition="section.imagePosition" :extraContent="section.extraContent">
        <!-- Slot image personnalisé -->
      </sectionCard>

      <div class="mx-auto flex flex-col items-start justify-center w-full p-4 mb-1">
        <a href="mailto:info@animauxdelasecondechance.com?subject=Demande%20d'adoption"
          class="bg-action hover:bg-primaire shadow-lg text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primaire focus:ring-opacity-50">Faire
          une demande d'adoption
        </a>
      </div>
    </div>



  </section>

</template>

<script setup>
import Titre from '../composants/Titre.vue';
import SectionCard from '../composants/SectionCard.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import imgChatFenetre from '../assets/images/animaux_de_la_seconde_chance_1.webp';
import imgAnimaux2 from '../assets/images/animaux_de_la_seconde_chance_2.webp';
import imgSoins1 from '../assets/images/chat_soins1.webp';
import imgPetitsChatons from '../assets/images/petits_chatons.webp';
import imgPetitChatCompagnon from '../assets/images/petit_chat_compagnon.webp';
import imgChatRelax from '../assets/images/chat_relax.webp';
import imgJeuxPourChats from '../assets/images/jeux_pour_chats.webp';

const sections = [
  {
    title: 'Un foyer chaleureux :',
    content: [
      `Êtes-vous prêt à offrir un foyer aimant à l'un de nos petits pensionnaires? Nous
          sommes ravis de vous fournir ici toutes les informations essentielles concernant le processus d'adoption. `,
    ],
    imageSrc: imgChatFenetre,
    imageAlt: 'Chat à la fenêtre',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: "Faire une demande d'adoption :",
    content: [
      `Lorsque vous adoptez un animal de notre organisme, une contribution financière est demandée. Cette aide
          précieuse nous permet de poursuivre notre mission : sauver le plus d'animaux possible. Les fonds récoltés
          servent à couvrir les soins vétérinaires, y compris les traitements médicaux et la stérilisation des chats
          adultes.`,
    ],
    imageSrc: imgAnimaux2,
    imageAlt: 'Animaux de la seconde chance',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'left',
  },
  {
    title: "Quels sont les frais d'adoption ?",
    content: [
      `<ul class="pl-6 list-disc">
        <li>
          Chaton moins de 5 mois vacciné, vermifugé&nbsp;: 110&nbsp;$.
          <br><span class="italic"><span class="text-red-500">Note</span>: La stérilisation et/ou la castration est au frais de l'adoptant.</span>
        </li>
        <li>
          Chat mâle 5 mois & plus - castré, vacciné, vermifugé&nbsp;: 160&nbsp;$.
        </li>
        <li class="tracking-tight">
          Chat femelle 5 mois & plus - stérilisée, vaccinée, vermifugée&nbsp;: 200&nbsp;$.
        </li>
        <li>
          Chat de race Lynx Highland - stérilisé, vacciné, vermifugé&nbsp;: 500&nbsp;$.
        </li>
        <li>
          Chat dégriffé - stérilisé, vacciné, vermifugé&nbsp;: 200&nbsp;$.
        </li>
      </ul>`
    ],
    imageSrc: imgSoins1,
    imageAlt: 'Chat qui se fait soigner',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: "Pour éviter que d'autres chats soient abandonnés:",
    content: [
      ` Pour éviter que d'autres chats ne soient abandonnés à l'avenir, nous demandons à tous les adoptants de faire stériliser les chatons adoptés. De plus, nous souhaitons que chaque chat trouve un foyer chaleureux, car certains de nos petits rescapés ont connu des vies difficiles.`,
    ],
    imageSrc: imgPetitsChatons,
    imageAlt: 'Petits chatons',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'left',
  },
  {
    title: 'Vous avez trouvé un chat que vous voulez adopter :',
    content: [
      `
       Une fois votre choix fait, veuillez nous contacter par&nbsp;: <a href='mailto:info@animauxdelasecondechance.com?subject=Info%20adoption' class='text-navigation hover:underline font-bold'>courriel</a> en mentionnant les noms des animaux qui vous
          intéressent ainsi que votre numéro de téléphone. Nous vous répondrons rapidement avec les informations
          demandées.`,
    ],
    imageSrc: imgPetitChatCompagnon,
    imageAlt: 'Une fille avec son petit chat',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: "Une période d'adaptation :",
    content: [
      ` Lors de l'adoption d'un chat provenant de notre organisme, vous bénéficiez d'une période d'adaptation d'une semaine. Passé ce délai, nous ne pourrons malheureusement pas rembourser le don effectué, car il aura été utilisé pour sauver un autre animal. Cependant, nous nous engageons à reprendre l'animal pour lui trouver un nouveau foyer si nécessaire. Merci de votre compréhension!`,
    ],
    imageSrc: imgChatRelax,
    imageAlt: 'Chat sur une chaise',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'left',
  },
  {
    title: 'Nos petits pensionnaires vous disent merci!',
    content: [
      `Au nom de tous nos petits
          pensionnaires, qu'ils soient déjà adoptés ou en attente d'un foyer, nous vous remercions de choisir notre organisation`,
      `Adopter un chat abandonné c'est <span class='text-primaire font-bold italic'>sauver</span> une vie.`,
    ],
    imageSrc: imgJeuxPourChats,
    imageAlt: 'Jeux pour chats',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
]
</script>

<style scoped>
section {
  overflow-x: hidden;
}

img {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

section {
  overflow-x: hidden;
}

</style>